// Services
import "DS/font-service";
// Boilerplates
import { NavTeslaFullScreen } from "CompLibTheme/boilerplates/nav-tesla-full-screen";
import "CompLibTheme/boilerplates/footer-4col";
import { ExoviaSmoothScrolling } from "CompLib/services/gsap-smooth-scrolling-page";
import { ToggleFixedNavbarStyles } from "CompLib/services/toggle-fixed-navbar-styles";
import "CompLibTheme/starter-embert";

// Components
import "CompLib/services/full-size-image-background";
import "CompLibTheme/links/exovia-swipe";
import "CompLibTheme/links/exovia-ripple";
import "CompLib/links/diagonal-swipe";

// Instatiations BP

new ToggleFixedNavbarStyles();
const smoothScroll = new ExoviaSmoothScrolling();
new NavTeslaFullScreen({ smoothScroll });
// new Cf7TemplateGDPR();

// import 'page styles last';
import "./scss/styles.scss";
